export const ThemeColor = "#225b76";
export const LightGray = "#e9e9e9";
export const DarkGray = "#989898";
export const overlay = "#215c75";
export const replyIcon = "#343333";
export const Orange = "#e25601";
